import { jsx } from 'react/jsx-runtime';
import React, { useContext } from 'react';

const initialState = {
    isMobile: false,
};
const DeviceContext = React.createContext(initialState);
const DeviceProvider = ({ value, children, }) => {
    return (jsx(DeviceContext.Provider, Object.assign({ value: value }, { children: children }), void 0));
};
function useDevice() {
    const context = useContext(DeviceContext);
    if (!context) {
        throw new Error('useDevice must be inside a DeviceProvider with a state value');
    }
    return context;
}

export { DeviceProvider, useDevice };
